export default "__VITE_ASSET__BnyJ_TeX__"